import * as React from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';

import CharacterPosition from './CharacterPosition';

import Position from '../../../../../../../domain/value_objects/Position';

import SceneFrame from '../../../../../../view_models/SceneFrame';

interface Props {
  sceneFrame: SceneFrame;
  width: number;
  onSelectPosition: (position: Position) => void;
}

export default class CharacterPositionList extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    const {sceneFrame, width, onSelectPosition} = this.props;
    const imageWidth = Math.ceil(
      (width -
        (CONTAINER_MARGIN_HORIZONTAL +
          CONTENT_MARGIN_HORIZONTAL * NUM_COLUMNS) *
          2) /
        NUM_COLUMNS,
    );
    return (
      <View style={styles.container}>
        <CharacterPosition
          characterSceneCommandForm={
            sceneFrame.isActive(Position.Left) ? sceneFrame.leftCharacter : null
          }
          position={Position.Left}
          width={imageWidth}
          onSelectPosition={onSelectPosition}
        />
        <CharacterPosition
          characterSceneCommandForm={
            sceneFrame.isActive(Position.Center)
              ? sceneFrame.centerCharacter
              : null
          }
          position={Position.Center}
          width={imageWidth}
          onSelectPosition={onSelectPosition}
        />
        <CharacterPosition
          characterSceneCommandForm={
            sceneFrame.isActive(Position.Right)
              ? sceneFrame.rightCharacter
              : null
          }
          position={Position.Right}
          width={imageWidth}
          onSelectPosition={onSelectPosition}
        />
      </View>
    );
  }
}

const CONTAINER_MARGIN_HORIZONTAL = 10;
const CONTENT_MARGIN_HORIZONTAL = 6;
const NUM_COLUMNS = 3;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    alignSelf: 'center',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    marginHorizontal: CONTAINER_MARGIN_HORIZONTAL,
  } as ViewStyle,
});
